angular.module('bmsApp.fees').factory('FeeSvc', function ($rootScope, $http, $log, $window, $q, CRUDSvc, $modal) {
	return {
		index: function (params) {
			return CRUDSvc.get('api/fees/index', params);
		},
		breakdown: function(params) {
			return CRUDSvc.get('api/fees/breakdown', params);
		},
		unsubmitted: function(params) {
			return CRUDSvc.get('api/fees/unsubmitted', params);
		},
		submit: function(params) {
			return CRUDSvc.post('api/fees/submit', params);
		},
		submitSlidingScaleFee: function(params) {
			return CRUDSvc.post('api/fees/submitSlidingScaleFee', params);
		},
		getSalesBreakdown:function(params){
			return CRUDSvc.get('api/fees/salesBreadown', params);

		},
		rejectFee: function(params) {
			return CRUDSvc.post('api/fees/reject', params);
		},
		showOpenVisitsModal: function(visits) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/fees/templates/OpenVisits.html',
				controller: 'OpenVisitsCtrl',
				size: 'md',
				scope: $rootScope,

				resolve: {
					visits: function () {
						return angular.copy(visits);
					}
				}
			});

			return modalInstance.result;
		},
		showLicenseBreakdownModal: function(fee, readonly) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/fees/templates/LicenseBreakdownModal.html',
				controller: 'LicenseBreakdownModalCtrl',
				controllerAs: 'LicenseBreakdown',
				size: 'lg',
				scope: $rootScope,

				resolve: {
					readonlyForm: readonly,
					fee: function () {
						return angular.copy(fee);
					}
				}
			});

			return modalInstance.result;
		},

		showSlidingFeeBreakdownModal: function(fee, scales,readonly) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/fees/templates/SlidingFeeBreakdownModal.html',
				controller: 'SlidingFeeBreakdownModalCtrl',
				controllerAs: 'SlidingFeeBreakdown',
				size: 'lg',
				scope: $rootScope,

				resolve: {
					scales: function(){
						return scales;
					},
					readonlyForm: readonly,
					fee: function () {
						return angular.copy(fee);
					}
				}
			});

			return modalInstance.result;
		},
		showFeeBreakdownModal: function(fee) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/fees/templates/FeeBreakdownModal.html',
				controller: 'FeeBreakdownModalCtrl',
				controllerAs: 'FeeBreakdown',
				size: 'lg',
				scope: $rootScope,

				resolve: {
					fee: fee
				}
			});

			return modalInstance.result;
		},
		showFeeInformationModal: function(fee) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/fees/templates/DeductionsModal.html',
				controller: 'DeductionsModalCtrl',
				controllerAs: 'Deduction',
				size: 'lg',
				scope: $rootScope,

				resolve: {
					fee: function () {
						return angular.copy(fee);
					}
				}
			});

			return modalInstance.result;
		},
	}
});




